import React from 'react';
import InfoBox from '../../components/info-box/info-box.jsx';
import Seo from '../../Seo.js';
import './about-wrapper.css';

const AboutWrapper = ({data}) => {

  return (
    <div className="about-wrapper dark-background">
        <Seo title="About Us" description={data?.aboutUs?.metaDescription} />
        <div className="row about-us-wrapper">
          <InfoBox title={data.aboutUs.title} text={data.aboutUs.text}/>
        </div>
        <div className='footer full-width margin-top-5'>
          <div className="container center">
            <p>&copy; {data.footer.text}</p>
          </div>
        </div>
    </div>
  );

}

export default AboutWrapper;
